exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ideal-alert .element-box {\n  padding: 0 !important; }\n\n.ideal-alert h5, .ideal-alert p {\n  color: #404950; }\n\n.ideal-alert .chat-btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.775rem;\n  line-height: 1.5;\n  border-radius: 4px;\n  text-align: center;\n  margin-bottom: .2rem;\n  margin-left: auto;\n  margin-right: auto; }\n\n.alertWithMessage .btn {\n  background-color: white !important; }\n", ""]);

// exports
